import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config, { API_PKI } from '../config';

const HeaderComponent = ({ changeLanguage }) => {
  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "ru"
  );

  useEffect(() => {
    i18n.changeLanguage(language); // применяем язык при загрузке
    localStorage.setItem("language", language);
  }, [language, i18n]);

  const switchLanguage = (lng) => {
    setLanguage(lng);
    localStorage.setItem("language", lng); // сохраняем язык
    i18n.changeLanguage(lng);
    if (changeLanguage) changeLanguage(lng); // callback если есть
  };
  
  const getPkiUrl = () => {
  return language === "kz" 
    ? "https://pki.gov.kz/kk/"  // казахская главная
    : "https://pki.gov.kz/";    // русская главная
};


  return (
    <div id="header">
      <div id="header-content">
        <a 
          href={getPkiUrl()}
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <div>
            <h1 className="toph">{t('header.title')}</h1>
            <h2 className="both">{t('header.subtitle')}</h2>
          </div>
        </a>

        <div className="s_l">
          <div className="lang">
            <div id="jflanguageselection">
              <form id="languageForm" className="form-hidden">
                <ul className="jflanguageselection">
                  <li id={language === 'kz' ? "active_language" : ""}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        switchLanguage('kz');
                      }}
                    >
                      <span lang="kz">KZ</span>
                    </a>
                  </li>
                  <li id={language === 'ru' ? "active_language" : ""}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        switchLanguage('ru');
                      }}
                    >
                      <span lang="ru">RU</span>
                    </a>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="menu">
        <div id="menu2">
          <ul className="menu-main">
            <li style={{ borderLeftWidth: '0px' }}>
              <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('header.log')}</h3>
              </Link>
            </li>

            <li style={{ borderLeftWidth: '0px' }}>
              <Link to="/get-sdk" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('header.link1')}</h3>
              </Link>
            </li>

            <li style={{ borderLeftWidth: '0px' }}>
              <Link to="/auth" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('header.link2')}</h3>
              </Link>
            </li>

            <li style={{ borderLeftWidth: '0px' }}>
              <Link to="/user-check" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('header.link3')}</h3>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
